import * as z from 'zod';

import { fileQuerySchema } from '../file';

export const teamMemberQueryLinkerSchema = z.object({
  id: z.number(),
  first_name: z.string(),
  last_name: z.string(),
  profile_image: z.array(fileQuerySchema).nullish(),
});

export type TeamMemberQueryLinkerSchema = z.infer<typeof teamMemberQueryLinkerSchema>;
